/* eslint-disable no-unused-vars */
import React from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Input, Select, Table } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Controller, useForm, useWatch } from 'react-hook-form';
import usePaginationHook from '../../../../utils/usePagination';
import dayjs from 'dayjs';
import fitCheckingServices from '../../../../services/fit-checking.services';
import 'dayjs/locale/th';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { IoMdSettings } from 'react-icons/io';

dayjs.locale('th');

const pageSize = 10;

const CheckinUserPage = () => {
  const history = useHistory();
  const {
    data: userLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();

  const [teamNames, setTeamNames] = React.useState([]);

  const { control } = useForm({
    defaultValues: {
      searchText: '',
      memberType: undefined,
      TeamName: undefined,
    },
  });

  const searchText = useWatch({ control, name: 'searchText' });
  const filterMemberType = useWatch({ control, name: 'memberType' });
  const filterTeamName = useWatch({ control, name: 'TeamName' });

  fitCheckingServices.useQueryGetTeamNames((data) => {
    setTeamNames(data);
  });

  fitCheckingServices.useQueryGetCheckingUsers(
    {
      take: pageSize,
      page,
      searchText,
      memberType: filterMemberType || undefined,
      TeamName: filterTeamName || undefined,
    },
    (data) => {
      setData(data.data);
      setTotal(data.meta.total);
    },
  );

  const columns = [
    {
      title: 'NO',
      dataIndex: 'index',
      key: 'index',
      render: (_, _record, index) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      title: 'รูปโปรไฟล์',
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      render: (_, record) => (
        <div style={{ width: 40, height: 40 }}>
          {record.user?.imageUrl && (
            <img
              alt=""
              src={record.user.imageUrl}
              style={{
                width: 40,
                height: 40,
                objectFit: 'cover',
                borderRadius: 100,
              }}
            />
          )}
        </div>
      ),
    },
    {
      title: 'รหัสนักธุรกิจ',
      dataIndex: 'memberCode',
      key: 'memberCode',
      render: (_, record) => <span>{record.memberCode || '-'}</span>,
    },
    {
      title: 'ชื่อ-สกุล',
      dataIndex: 'FirstNameTh',
      key: 'FirstNameTh',
      render: (_, record) => (
        <>
          <div>
            {record.user?.FirstNameTh || '-'} {record.user?.SurNameTh || '-'}
          </div>
          {record.partner && (
            <div>
              {record.partner?.FirstNameTh &&
                record.partner?.SurNameTh &&
                `และ ${record.partner?.FirstNameTh} ${record.partner?.SurNameTh}`}
            </div>
          )}
        </>
      ),
    },
    {
      title: 'ชื่อเล่น',
      dataIndex: 'FirstNameTh',
      key: 'FirstNameTh',
      render: (_, record) => (
        <>
          <div>{record.user?.NickName || '-'}</div>
          {record.partner && (
            <div>
              {record.partner.NickName && `และ ${record.partner.NickName}`}
            </div>
          )}
        </>
      ),
    },
    {
      title: 'ประเภทนักธุรกิจ',
      dataIndex: 'memberType',
      key: 'memberType',
      render: (_, record) => (
        <span>
          {record.memberType === 'Distributor' && 'นักธุรกิจ'}
          {record.memberType === 'Member' && 'VIP Member'}
        </span>
      ),
    },
    {
      title: 'องค์กร',
      dataIndex: 'TeamName',
      key: 'TeamName',
      render: (_, record) => <span>{record.user?.TeamName || '-'}</span>,
    },
    {
      title: 'รหัสผู้แนะนำ',
      dataIndex: 'SponsorCode',
      key: 'SponsorCode',
      render: (_, record) => <span>{record.user?.SponsorCode || '-'}</span>,
    },
    {
      title: 'ชื่อผู้แนะนำ',
      dataIndex: 'SponsorName',
      key: 'SponsorName',
      render: (_, record) => <span>{record.user?.SponsorName || '-'}</span>,
    },
    {
      title: 'เช็คอินล่าสุด',
      dataIndex: 'latestCheckin',
      key: 'latestCheckin',
      render: (_, record) => (
        <span>
          {record.latestHistory?.createdAt
            ? dayjs(record.latestHistory.createdAt).format('DD MMM YYYY HH:mm')
            : '-'}
        </span>
      ),
    },
    {
      title: 'สาขาเช็คอินล่าสุด',
      dataIndex: 'latestBranch',
      key: 'latestBranch',
      render: (_, record) => (
        <span>
          {record.latestHistory?.branchData?.Name ||
            record.latestHistory?.branch?.branchRefId ||
            '-'}
        </span>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div
          style={{ display: 'flex', justifyContent: 'flex-end' }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{ cursor: 'pointer', marginLeft: 10 }}
            onClick={() => {
              history.push(`/checkin-branch/user/${record.id}`);
            }}
          >
            <IoMdSettings />
          </div>
        </div>
      ),
    },
  ];

  return (
    <Panel>
      <PanelHeader>ข้อมูลสมาชิก</PanelHeader>
      <PanelBody>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            marginBottom: 16,
            gap: 8,
          }}
        >
          <Controller
            name="memberType"
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <Select
                  value={value}
                  style={{ width: 200 }}
                  onChange={onChange}
                  placeholder="ประเภทนักธุรกิจ"
                  className="mr-2"
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                >
                  {[
                    { label: 'ทั้งหมด', value: '' },
                    { label: 'นักธุรกิจ', value: 'Distributor' },
                    { label: 'VIP Member', value: 'Member' },
                  ].map((item) => {
                    return (
                      <Select.Option key={item.value} value={item.value}>
                        {item.label}
                      </Select.Option>
                    );
                  })}
                </Select>
              );
            }}
          />
          <Controller
            name="TeamName"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Select
                value={value}
                style={{ width: 200 }}
                onChange={onChange}
                placeholder="องค์กร"
                className="mr-2"
                allowClear
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              >
                <Select.Option value={undefined}>ทั้งหมด</Select.Option>
                {teamNames.map((item) => (
                  <Select.Option key={item.id} value={item.TeamName}>
                    {item.TeamName}
                  </Select.Option>
                ))}
              </Select>
            )}
          />
          <Controller
            name="searchText"
            control={control}
            render={({ field: { onChange, value } }) => (
              <Input
                placeholder="ค้นหารหัส, ชื่อ, สกุล"
                prefix={<SearchOutlined />}
                value={value}
                onChange={(e) => {
                  onChange(e);
                  setPage(1);
                }}
                style={{ width: 350 }}
                allowClear
              />
            )}
          />
        </div>
        <Table
          columns={columns}
          dataSource={userLists}
          style={{ backgroundColor: '#fff' }}
          rowKey="id"
          scroll={{ x: 'max-content' }}
          onChange={({ current }) => {
            setPage(current);
          }}
          pagination={{
            pageSize,
            total,
          }}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                history.push(`/checkin-branch/user/${record.id}`);
              },
            };
          }}
        />
      </PanelBody>
    </Panel>
  );
};

export default CheckinUserPage;
